module.exports = __webpack_public_path__ + "img/helper4.63dd60bc.png";